export default class Api {
    constructor() { }

    call(requestType, url, data = null) {
        return new Promise((resolve, reject) => {
            const locale = window.location.pathname.split('/')[1] || 'en';

            // Configure headers
            const config = {
                headers: {
                    'Accept-Language': locale
                }
            };

            const request = requestType.toLowerCase() === 'get'
                ? axios[requestType]('/api/' + url, config)
                : axios[requestType]('/api/' + url, data, config);

            request
                .then(response => {
                    resolve(response.data);
                })
                .catch(({ response }) => {
                    if (response.status === 401) {
                        window.location.href = '/login'
                    }
                    reject(response);
                });
        });
    }
}
